import { useContext } from 'react';
import AppContext from "../contexts/appContext";
import masks from '../utils/masks';
import { emptyIfNull } from '../utils/formatters'
import { enumSituacao } from '../components/OfferDetails/OfferDetails';
import api from "../utils/api";
import dateUtils from "../utils/date";


const buildParam = (key, value) => `${encodeURIComponent(`${key}=`)}${value}`;

const basicParams = () =>
    [buildParam('name', 'VISITANTE'),
    buildParam('email', 'VISITANTE@VISITANTE.COM.BR'),
    buildParam('phone', '111111111'),
    ].join('&');

const consortiumDatas = (
    identifier = '',
    product = '',
    simulationValue = '',
    value = '',
    group = '',
    creditValue = '',
    term = '',
    situationGroup = '',
    CPFCNPJ = '',
    incomeOrRevenues = '',
    spouseIncome = '',
    document = '',
    birthDateOrFoundationDate = '',
    maritalStatus = '',
    sex = '',
    profession = '',
    motherName = '',
    CEP = '',
    insurance = '',
    paymentMethods = '',
    proposal = '',
    legalNature = '',
    branchActivity = '',
    capitalValue = '',
    associatesCPF = '',
    name = '',
    email = '',
    phone = ''
) =>
    [
        buildParam('NomeOuRazaoSocial', name),
        buildParam('Email', email),
        buildParam('Celular', phone),
        buildParam('Identificador', identifier),
        buildParam('Produto', product),
        buildParam('Simulacao', simulationValue),
        buildParam('ValorParcela', value),
        buildParam('Grupo', group),
        buildParam('ValorCredito', creditValue),
        buildParam('Prazo', term),
        buildParam('SituacaoGrupo', `${situationGroup}`),
        buildParam('CPFCNPJ', CPFCNPJ),
        buildParam('RendaOuFaturamento', incomeOrRevenues),
        buildParam('RendaConjuge', spouseIncome),
        buildParam('RGOuDocumento', document),
        buildParam('DtNascimentoOuDtFundacao', dateUtils.formatToChat(birthDateOrFoundationDate)),
        buildParam('StCivil', maritalStatus),
        buildParam('Sexo', sex),
        buildParam('Profissao', profession),
        buildParam('NomeMae', motherName),
        buildParam('CEP', CEP),
        buildParam('Seguro', insurance),
        buildParam('FormaPagamento', paymentMethods),
        buildParam('Proposta', proposal),
        buildParam('NaturezaJuridica', legalNature),
        buildParam('RamoAtividade', branchActivity),
        buildParam('ValorCapitalSocial', capitalValue),
        buildParam('CPFSocios', associatesCPF)
    ].join(encodeURIComponent(' ; '));



const formatParameter = (condition, value) => {
    return emptyIfNull(condition && value());
};

const chatHandler = (context, basicParams, otherParams) => {
    window.open(
        `${context.product.id === "1" ? api.endpoints.DIRECT_CHAT().imovel : api.endpoints.DIRECT_CHAT().veiculo}${basicParams}&cotacao=${otherParams}`,
        '_blank',
        'width=795, height=590, top=100, left=699, status=no, toolbar=no, menubar=no, resizable=no, fullscreen=no'
    );
};

const partners = (partners) => {
    return partners.map(data => data.identificacao.codigo).join();
}

const useChatUrl = () => {
    const context = useContext(
        AppContext
    );

    const isClient = context.client && context.client.pessoa;
    const path = window.location.pathname;
    const page = path.split("/").pop();
    const getChatLink = () => {
        return `${consortiumDatas(
            page,
            context.product.nome,
            formatParameter(context.simulationValue, () => masks.currency(context.simulationValue.toString())),
            formatParameter(context.selectedOffer, () => masks.currency(context.selectedOffer.dados.valorParcela.toString())),
            formatParameter(context.selectedOffer, () => context.selectedOffer.identificacao.codigoNegocio),
            formatParameter(context.selectedOffer, () => masks.currency(context.selectedOffer.dados.valorCredito.toString())),
            formatParameter(context.selectedOffer, () => context.selectedOffer.dados.plano.prazo.total),
            formatParameter(context.selectedOffer, () => enumSituacao[context.selectedOffer.dados.situacao]),
            formatParameter(context.document, () => context.document),
            formatParameter(context.incomeValue, () => context.incomeValue),
            formatParameter(context.secondaryIncomeValue, () => masks.currency(context.secondaryIncomeValue.toString())),
            formatParameter(context.copyPerson, () => formatParameter(context.copyPerson.dadosPessoaJuridica, () => context.copyPerson.dadosPessoaJuridica.documento.codigo)),
            formatParameter(context.copyPerson, () => context.copyPerson.dadosPessoaFisica ? context.copyPerson.dadosPessoaFisica.dataNascimento : context.copyPerson.dadosPessoaJuridica.dataFundacao),
            formatParameter(isClient, () => formatParameter(context.client.pessoa.dadosPessoaFisica, () => context.client.pessoa.dadosPessoaFisica.estadoCivil.valor)),
            formatParameter(isClient, () => formatParameter(context.client.pessoa.dadosPessoaFisica, () => context.client.pessoa.dadosPessoaFisica.sexo.valor)),
            formatParameter(isClient, () => formatParameter(context.client.pessoa.dadosPessoaFisica, () => context.client.pessoa.dadosPessoaFisica.profissao.valor)),
            formatParameter(isClient, () => formatParameter(context.client.pessoa.dadosPessoaFisica, () => context.client.pessoa.dadosPessoaFisica.filiacao.mae)),
            formatParameter(isClient, () => context.client.pessoa.endereco.cep),
            formatParameter(context.insurance, () => context.insurance),
            formatParameter(context.paymentType, () => context.paymentType),
            formatParameter(context.proposalCode, () => context.proposalCode),
            formatParameter(isClient, () => formatParameter(context.client.pessoa.dadosPessoaJuridica, () => context.client.pessoa.dadosPessoaJuridica.ocupacao.valor)),
            formatParameter(isClient, () => formatParameter(context.client.pessoa.dadosPessoaJuridica, () => context.client.pessoa.dadosPessoaJuridica.atividade.valor)),
            formatParameter(isClient, () => formatParameter(context.client.pessoa.dadosPessoaJuridica, () => masks.currency(context.client.pessoa.dadosPessoaJuridica.informacoesEconomicas.valorCapital.toString()))),
            formatParameter(context.copyPerson, () => formatParameter(context.copyPerson.dadosPessoaJuridica, () => partners(emptyIfNull(context.copyPerson.dadosPessoaJuridica.socios)))),
            formatParameter(context.copyPerson, () => context.copyPerson.nome),
            formatParameter(context.copyPerson, () => context.copyPerson.comunicacao.email),
            formatParameter(context.copyPerson, () => `${context.copyPerson.comunicacao.telefones[0].ddd}${context.copyPerson.comunicacao.telefones[0].numero}`),
        )
            }`;
    }
    const callChat = () => {
        chatHandler(context, basicParams(), getChatLink());
    };
    return { callChat };
};

export default useChatUrl;